module.exports = new __parcel__URL__("B2.1d18af81.mp3").toString();